
import { addGroup, delScource, getKnowledgeScourceList, renameResources} from "@/api/knowledge";
import { UserModule } from "@/store/modules/user";
import TemplateAddress from "@/views/template/TemplateAddress.vue";
import { number } from "echarts";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  name: "knowledgeDirectory",
  components: { TemplateAddress },
})
export default class extends Vue {
  private islazy = false;
  private tableData=[];
  private maps:any = new Map()
  @Prop({
    type: Object,
    default: () => {}
  })
  expandData:any;
  @Prop({
    type: Object,
    default: () => {}
  })
  refData:any;
  @Prop({
    type: Number,
    default: 0
  })
  isLook:any;

  @Watch('expandData', {
    deep: true,
    immediate: true
  })
  handleChangeProps() {
    if (this.expandData && this.expandData.id && this.$refs.tree && (this.$refs.tree as any).store) {
      let nodes:any = (this.$refs.tree as any).store.nodesMap;
      for (var i in nodes) {
        if (nodes[i].data.id === this.expandData.id) {
          nodes[i].expand()
        }
      }
    }
  }
  @Watch('refData', {
    deep: true,
    immediate: true
  })
  handleRefChangeProps() {
    this.refsData(this.refData.id)
  }

  created() {
    this.getKnowledgeScourceList('0', '')
  }
  private getKnowledgeScourceList(pid: any, resolve:any) {
    let params:any = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      is_child_folder_num: 1,
      type: 0,
      pid: pid,
      is_collection: 1,
      page: 1,
      size: 9999,

    };
    getKnowledgeScourceList(params).then(res => {
      if (pid && pid !== '0') {
        if (res.data && res.data.list) {
          let dataTable:any = res.data.list;
          resolve(dataTable);
        } else {
          resolve([]);
        }
      } else {
        if (res.data && res.data.list) {
          this.tableData = res.data.list;
        } else {
          this.tableData = [];
        }
      }
    })
  }
  load(node:any, resolve:any) {
    if (node && node.data && node.data.id) {
      this.maps.set(node.data.id, { node, resolve });
      this.getKnowledgeScourceList(node.data.id, resolve);
      this.$emit('changeNode', node.data)
    } else {
      this.getKnowledgeScourceList('0', '');
    }
  }
  private nodeClick(data:any, node:any, view:any) {
    this.$emit('changeNode', data)
    node.expand()
  }
  private nodeCollapse() {

  }
  private refsData(id:any) {
    if (this.maps.get(id)) {
      const { node, resolve } = this.maps.get(id);
      this.load(node, resolve);
    } else {
      this.getKnowledgeScourceList('0', '');
    }
  }
  private topClick() {
    let nodes = (this.$refs.tree as any).store.nodesMap;
    for (var i in nodes) {
      nodes[i].expanded = false;
    }
    let data = { id: '0' }
    this.$emit('changeNode', data)
  }
  private addHandle(data:any) {
    this.$prompt('名称', '群组名称', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '请输入群组名称',
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,30}$/,
      inputErrorMessage: '请输入1-30位由数字、字母、中文组成的名称',
      inputValue: ''
    })
      .then(({ value }: any) => {
        let params:any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          pid: (data && data.id) ? data.id : '0',
          name: value,
        }
        addGroup(params).then((res:any) => {
          this.showSuccessMsg(res.msg)
          this.refsData(((data && data.id) ? data.id : '0'))
        })
      })
      .catch(() => {

      });
  }
  private renameHandle(row: any) {
    this.$prompt("名称", "群组名称", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      inputPlaceholder: "请输入群组名称",
      inputPattern: /^[A-Za-z0-9\u4e00-\u9fa5]{1,30}$/,
      inputErrorMessage: "请输入1-30位由数字、字母、中文组成的名称",
      inputValue: row.name,
    })
      .then(({ value }: any) => {
        let params: any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          id: row.id,
          name: value,
        };
        renameResources(params)
          .then((res: any) => {
            this.showSuccessMsg(res.msg);
            this.refsData(row.pid)
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }
  private deleteHandle(data:any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let params:any = {
          user_id: UserModule.getUserId,
          user_name: UserModule.getUserName,
          company_id: UserModule.getCompanyId,
          id: data.id,
        }
        delScource(params).then((res:any) => {
          this.showSuccessMsg(res.msg)
          this.refsData(data.pid)
        })
      })
      .catch(() => {});
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
